/**
 * Iter60.p43.6 — Module ID chip.
 *
 * Small pill rendering the employee's real-world Module ID (badge /
 * biometric device ID like `214L`, `AP003`, `017L`). This is what
 * operators actually recognise on the ground — the EMP-#### code is
 * a system identifier they don't use daily.
 *
 * Used in:
 *   * ManualAttendanceDialog employee dropdown option label
 *   * BulkAttendanceDialog employee row primary identifier
 *   * (anywhere else that needs a compact real-world ID pill)
 *
 * Falls back to a muted `—` chip when the employee has no Module ID
 * so the layout doesn't shift.
 */
import React from "react";

export default function ModuleIdChip({ value, testid, size = "sm" }) {
    const present = !!(value && String(value).trim());
    const label = present ? String(value).trim() : "—";
    const isSm = size === "sm";
    return (
        <span
            className="asl-mid-chip mono inline-flex items-center justify-center whitespace-nowrap"
            style={{
                minWidth: isSm ? 44 : 56,
                padding: isSm ? "2px 8px" : "3px 10px",
                fontSize: isSm ? 11 : 12,
                fontWeight: 700,
                lineHeight: 1.1,
                borderRadius: 6,
                background: present
                    ? "rgba(168, 50, 74, 0.10)"
                    : "rgba(0, 0, 0, 0.04)",
                color: present
                    ? "var(--asl-crimson, #A8324A)"
                    : "var(--asl-text-3)",
                border: present
                    ? "1px solid rgba(168, 50, 74, 0.18)"
                    : "1px solid var(--asl-divider, rgba(0,0,0,0.08))",
                letterSpacing: 0.02,
            }}
            data-testid={testid}
        >
            {label}
        </span>
    );
}
